module.exports = __webpack_public_path__ + "static/media/34DSS6.a25ae20b.jpg";